import { useEffect } from 'react'
import { SnappingFeaturesEnabled, useControlStore } from '@editorStores'

const defaultSnapTargetConfig = () => {
  return {
    snapToCornersAndEdges: true,
    snapToAngle: true,
    snapOrthogonal: true,
    snapToTapelineCenters: true,
    snapToComments: true,
  } as SnappingFeaturesEnabled
}

export enum SnapTargetElementType {
  WALLS = 'walls',
  PURLINS = 'purlins',
  COLUMNS = 'columns',
  BEAMS = 'beams',
  VERTICAL_SLABS = 'vertical_slabs',
  VERTICAL_ROOF_SLABS = 'vertical_roof_slabs',
}

export const defaultSnapTargets: Record<SnapTargetElementType, SnappingFeaturesEnabled> = {
  walls: defaultSnapTargetConfig(),
  purlins: defaultSnapTargetConfig(),
  columns: defaultSnapTargetConfig(),
  beams: defaultSnapTargetConfig(),
  vertical_slabs: defaultSnapTargetConfig(),
  vertical_roof_slabs: defaultSnapTargetConfig(),
}

export const useDefault2DSnapConfigForElementType = (elementType: SnapTargetElementType) => {
  const setSnapOrthogonal = useControlStore(state => state.setSnapOrthogonal)
  const setSnapToAngles = useControlStore(state => state.setSnapToAngles)
  const setSnapToCornersAndEdges = useControlStore(state => state.setSnapToCornersAndEdges)
  const setSnapToTapelineCenters = useControlStore(state => state.setSnapToTapelineCenters)

  return useEffect(() => {
    const config = defaultSnapTargets[elementType]
    setSnapOrthogonal(config.snapOrthogonal)
    setSnapToAngles(config.snapToAngle)
    setSnapToCornersAndEdges(config.snapToCornersAndEdges)
    setSnapToTapelineCenters(config.snapToTapelineCenters)
  }, [
    elementType,
    setSnapOrthogonal,
    setSnapToAngles,
    setSnapToCornersAndEdges,
    setSnapToTapelineCenters,
  ])
}
